//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory, useLocation } from "react-router-dom";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';

// custom pages
import Table from "components/Table/Table";
import promotion from "apis/promotion/promotion";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";

// material-ui
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

//Helpers
import {dateFormat} from "helpers/dataFormat"

export default function Promotion(props) {
  const { state, dispatch } = useContext(context);
  const { getRange } = promotion();
  const history = useHistory();
  const location = useLocation();

  const classes = styles();

  const [data, setData] = useState([]);
  const [promotionData, setPromotionData] = useState({});
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const {t , i18n}= useTranslation()
  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "Range"],
    });
  }, []);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    if (location?.state?.data) {
      setPromotionData(location?.state?.data);
    }
  });

  // handling api calls
  useEffect(() => {
    if (location?.state?.id) {
      handleGet();
    }
  }, [offset]);

  // get api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
        promotionId: location?.state?.id,
      };
      let res = await getRange(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid xs={12} sm={12} lg={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            <strong>{t('Range')}</strong>
          </span>
          { 
          ((state?.userInfo?.role_id==10||state?.userInfo?.role_id==13)||moment(
            moment(promotionData?.start_date).format("MM/DD/YYYY")
          ).isAfter(moment().format("MM/DD/YYYY"))) && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                history.push("/dashboard/create-range", {
                  id: location?.state?.id,
                });
              }}
            >
              {t('Create')}
            </Button>
          )}
        </Grid>
      </Grid>

      <Grid container className={classes.promotionDetails}>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Promotion Id')}</strong> : {promotionData?.promotion_id}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Promotion Name')}</strong> : {promotionData?.promotion_name}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Promotion Description')}</strong> :{" "}
          {promotionData?.promotion_description}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Start Date')}</strong> :{" "}
          {promotionData?.start_date
            ? dateFormat(promotionData?.start_date,i18n.language)
            : "-"}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('End Date')}</strong> :{" "}
          {promotionData?.end_date
            ? dateFormat(promotionData?.end_date,i18n.language)
            : "-"}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Expired')}</strong> :{" "}
          {promotionData?.expired ? (
            <span style={{ color: "red" }}>{t('Yes')}</span>
          ) : (
            <span style={{ color: "green" }}>{t('No')}</span>
          )}
        </Grid>
        {/* <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Ranking')}</strong> : {promotionData?.ranking}
        </Grid> */}
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Type')}</strong> : {promotionData?.type}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Frequency')}</strong> : {promotionData?.frequency}
        </Grid>
      </Grid>

      <Grid className={classes.tableDownInResponsive}>
        <Grid xs={12} sm={12} lg={12}>
          {res ? (
            <Table
              headings={[
                "S.No",
                "Minimum Amount",
                "Maximum Amount",
                "Additional Multiplier",
                // "Sequence",
                "Active",
                (state?.userInfo?.role_id==10|| moment(
                  moment(promotionData?.start_date).format("MM/DD/YYYY")
                ).isAfter(moment().format("MM/DD/YYYY")))? "View":"",
              ]}

             
              data={
                data &&
                data.length > 0 &&
                data.map((d, i) => [
                  i + 1,
                  d?.minimum_amount,
                  d?.maximum_amount,
                  d?.multiplier,
                  // d?.sequence,
                  d?.is_active ? (
                    <span style={{ color: "green" }}>{t('True')}</span>
                  ) : (
                    <span style={{ color: "red" }}>{('False')}</span>
                  ),
                  ((state?.userInfo?.role_id==10||state?.userInfo?.role_id==13)|| moment(
                    moment(promotionData?.start_date).format("MM/DD/YYYY")
                  ).isAfter(moment().format("MM/DD/YYYY"))) && (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/view-range", { data: d });
                      }}
                    >
                      <VisibilityIcon />
                    </div>
                  ),
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          ) : (
            <Loader Loading={true} top={"15%"} />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
